import { http } from '../index';

export const getJobTaskVersions = params =>
  http
    .get('/job-task-versions/list', { params })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const createJobTaskVersion = formData =>
  http
    .post('/job-task-versions', formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const updateJobTaskVersion = (id, formData) =>
  http
    .put(`/job-task-versions/${id}`, formData)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const launchJobTaskVersion = id =>
  http
    .post(`/job-task-versions/${id}/launch`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const cancelJobTaskVersion = id =>
  http
    .post(`/job-task-versions/${id}/cancel`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const deleteJobTaskVersion = id =>
  http
    .delete(`/job-task-versions/${id}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const getJobTaskVersionRequirements = id =>
  http
    .get(`/job-task-versions/${id}/requirements`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const replaceJobTaskVersionRequirements = (id, data) =>
  http
    .put(`/job-task-versions/${id}/requirements`, data)
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const diffJobTaskVersionRequirements = (id, compareVersionId) =>
  http
    .get(`/job-task-versions/${id}/requirements/diff`, {
      params: { compareVersionId },
    })
    .then(res => res.data)
    .catch(error => error.response?.data || error);

export const cloneJobTaskVersionRequirements = (id, sourceVersionId) =>
  http
    .post(`/job-task-versions/${id}/requirements/clone-from/${sourceVersionId}`)
    .then(res => res.data)
    .catch(error => error.response?.data || error);
